import { LeftActivityAlertDialog } from "@/modules/activities/components/left-activity-alert-dialog"
import IdleDialog from "@/modules/activities/components/idle-dialog"
import mixpanel from "mixpanel-browser"
import { useEffect } from "react"
import { Outlet } from "react-router-dom"

export default function ActivitiesPage() {
  useEffect(() => {
    const timeout = setTimeout(() => {
      mixpanel.stop_session_recording()
    }, 1500)

    return () => clearTimeout(timeout)
  }, [])

  return (
    <section className="flex size-full">
      <LeftActivityAlertDialog />
      <IdleDialog />
      <Outlet />
    </section>
  )
}
